import { useEffect, useMemo, useRef, useState } from "react";
import useConfirm from "../hooks/useConfirm";
import useReservation from "../hooks/useReservationData";
import useWebData from "../hooks/useWebData";
import { branchTimezone } from "../utils/summaryCalculation";
import { getLocationOpenHours } from "../services/locationOpenHour";
import moment from "moment";
import axios from "axios";
import { baseURL, tenantId } from "../config/api";
import InputPicker from "./InputPicker";
import useReservationForm from "../hooks/useReservationForm";
import usePleaseWait from "../hooks/usePleaseWait";
import { CustomDateField } from "./CustomDateField";


export const UpdateReservationForm = () => {
    const { webData }: any = useWebData();
    const { showPopup, setShowPopup }: any = useReservationForm();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const {
        branchId,
        setBranchId,
        branches,
        locationOpenHourOfParticularBranch,
        setLocationOpenHourOfParticularBranch,
        updateResevation,
        formattedCreatedAt,
        pickupLocationId,
        setPickupLocationId,
        returnLocationId,
        setReturnLocationId,
        pickupDate,
        setPickupDate,
        returnDate,
        setReturnDate,
        pickupTime,
        setPickupTime,
        returnTime,
        setReturnTime,
        locations,
        setLocationFeeAmount,
        setTaxAmount,
        setMandatoryAdditionalChargesAmount,
        setGovernmentTaxAmount,
        returnToDifferent,
        setReturnToDifferent,
        timezoneOptionsIsLoaded,
        timezoneOptions,
        setFormattedCreatedAt
    }: any = useReservation();
    const { setPleasWaitPopup }: any = usePleaseWait();
    const [locationOptions, setLocationOptions] = useState<any[]>([]);
    const [upadatePickupLocationId, setUpadatePickupLocationId] = useState<any>(null);
    const [selectedLocation, setSelectedLocation] = useState<any>(null);
    const [updateBranch, setUpdateBranch] = useState<any>(null);
    const [pickupSearch, setPickupSearch] = useState<string>('');
    const [updatePickupDate, setUpdatePickupDate] = useState<any>(null);
    const [updatePickupTime, setUpdatePickupTime] = useState<any>(null);
    const [upadateReturnLocationId, setUpadateReturnLocationId] = useState<any>(null);
    const [updateReturnDate, setUpdateReturnDate] = useState<any>(null);
    const [updateReturnTime, setUpdateReturnTime] = useState<any>(null);
    const [returnSearch, setReturnSearch] = useState<string>('');
    const [pickupIsFocused, setPickupIsFocused] = useState<boolean>(false);
    const [pickupFilteredOptions, setPickupFilteredOptions] = useState<any[]>(locationOptions);
    const pickupWrapperRef = useRef<HTMLDivElement | null>(null);
    const [returnIsFocused, setReturnIsFocused] = useState<boolean>(false);
    const [returnFilteredOptions, setReturnFilteredOptions] = useState<any[]>(locationOptions);
    const [updateReturnToDifferent, setUpdateReturnToDifferent] = useState<boolean>(false);

    const [isValid, setIsValid] = useState<boolean>(false);
    const [returnTimeMessage, setReturnTimeMessage] = useState<string>("");
    const [minBookingMessage, setMinBookingMessage] = useState<string>("");

    const returnWrapperRef = useRef<HTMLDivElement | null>(null);
    const pickupTimeRef = useRef<HTMLInputElement>(null);
    const returnTimeRef = useRef<HTMLInputElement>(null);

    const UpdateTimezone = branchTimezone(formattedCreatedAt);

    useEffect(() => {
        if (showPopup) {
            setPickupFilteredOptions(locationOptions);
            setReturnFilteredOptions(locationOptions);
            setUpdateBranch(branchId);
            setUpadatePickupLocationId(pickupLocationId);
            setUpadateReturnLocationId(returnLocationId);
            setUpdatePickupDate(pickupDate);
            setUpdateReturnDate(returnDate);
            setUpdatePickupTime(pickupTime);
            setUpdateReturnTime(returnTime);
            setUpdateReturnToDifferent(returnToDifferent);
        }
    }, [showPopup, locationOptions, branchId, pickupDate, returnDate, pickupTime, returnTime, pickupLocationId, returnLocationId, returnToDifferent])

    useEffect(() => {
        if (branches && timezoneOptionsIsLoaded && parseInt(updateBranch) > 0) {
            const branch = branches?.find((item: any) => item?.id === parseInt(updateBranch));
            if (branch) {
                const offset = moment.tz(moment.tz.guess()).format('Z');
                const defaultTimeZone = `(GMT ${offset}) ${moment.tz.guess()} ${moment.tz(moment.tz.guess()).zoneAbbr()}`;

                const branchTimezone = branch?.timeZone;
                if (branchTimezone) {
                    if (parseInt(branchTimezone) > 0) {
                        const timeZoneData = timezoneOptions.find((item: any) => item.value === parseInt(branchTimezone));
                        if (timeZoneData) {

                            const timeData = new Date().toLocaleString("en-US", {
                                timeZone: timeZoneData?.label?.split(" ")[2]
                            });

                            setUpdatePickupTime(moment(timeData).format('HH:mm'));
                            setUpdateReturnTime(moment(timeData).format('HH:mm'));

                            setFormattedCreatedAt(timeZoneData?.label);
                        } else {

                            const timeData = new Date().toLocaleString("en-US", {
                                timeZone: moment.tz.guess()
                            });

                            setUpdatePickupTime(moment(timeData).format('HH:mm'));
                            setUpdateReturnTime(moment(timeData).format('HH:mm'));


                            setFormattedCreatedAt(defaultTimeZone);
                        }
                    } else {

                        const timeData = new Date().toLocaleString("en-US", {
                            timeZone: moment.tz.guess()
                        });

                        setUpdatePickupTime(moment(timeData).format('HH:mm'));
                        setUpdateReturnTime(moment(timeData).format('HH:mm'));


                        setFormattedCreatedAt(defaultTimeZone);
                    }
                } else {
                    setFormattedCreatedAt(defaultTimeZone);
                }
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateBranch, branches, timezoneOptionsIsLoaded]);

    useEffect(() => {
        if (!updateReturnToDifferent) {
            setUpadateReturnLocationId(upadatePickupLocationId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateReturnToDifferent])

    // Lock scroll when modal is open
    useEffect(() => {
        if (showPopup) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => document.body.classList.remove("overflow-hidden");
    }, [showPopup]);

    useEffect(() => {
        const handler = (e: any) => {
            if (pickupWrapperRef.current && !pickupWrapperRef.current.contains(e.target)) {
                setPickupIsFocused(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, []);

    useEffect(() => {
        const handler = (e: any) => {
            if (returnWrapperRef.current && !returnWrapperRef.current.contains(e.target)) {
                setReturnIsFocused(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, []);

    useEffect(() => {
        if (locations.length > 0 && showPopup) {
            const result = locations?.map((item: any) => {
                return {
                    value: item?.id,
                    label: `${[item?.street, item?.city, item?.state].filter(Boolean).join(', ')} (${item?.locationName || ''})`,
                    branchId: item?.branchId,
                    locationFee: item?.locationFee,
                    taxLabel: item?.taxLabel,
                    tax: item?.tax,
                    mandatoryAdditionalCharges: item?.mandatoryAdditionalCharges,
                    governmentTax: item?.governmentTax
                }
            })
            setPickupSearch(result?.find((item: any) => item.value === parseInt(pickupLocationId))?.label)
            setReturnSearch(result?.find((item: any) => item.value === parseInt(returnLocationId))?.label)
            setLocationOptions(result)
            setPickupFilteredOptions(result);
            setReturnFilteredOptions(result);
        } else {
            setLocationOptions([])
            setPickupFilteredOptions([]);
            setReturnFilteredOptions([])
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locations, showPopup])

    useEffect(() => {
        const results = locationOptions?.filter((opt) =>
            opt.label?.toLowerCase().includes(pickupSearch?.toLowerCase())
        );
        setPickupFilteredOptions(results);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pickupSearch, locationOptions]);

    useEffect(() => {
        const results = locationOptions?.filter((opt) =>
            opt.label?.toLowerCase().includes(returnSearch?.toLowerCase())
        );
        setReturnFilteredOptions(results);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [returnSearch, locationOptions]);

    useEffect(() => {
        if (parseInt(updateBranch) > 0 && showPopup) {
            getLocationOpenHours(tenantId)
                .then(data => {
                    setLocationOpenHourOfParticularBranch(data?.filter((item: any) => item.branchId === parseInt(updateBranch) && (new Date(item.startDate) <= new Date() && new Date(item.endDate) >= new Date())));
                })
                .catch((error) => {
                    console.log(error);
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateBranch]);

    useEffect(() => {
        if (locationOpenHourOfParticularBranch.length !== 0 && showPopup) {
            setTimeWithOpenHour(new Date(updatePickupDate), true);
            setTimeWithOpenHour(new Date(updateReturnDate), false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationOpenHourOfParticularBranch])

    const closeModal = () => setShowPopup(false);

    const setTimeWithOpenHour = (date: Date, isPickupTime: boolean) => {
        const currentTime = new Date(UpdateTimezone);
        switch (date.getDay()) {
            case 0:
                if (locationOpenHourOfParticularBranch[0]?.sundayOpenTime) {
                    if (isPickupTime) {
                        if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.sundayOpenTime, 'HH:mm'))) {
                            setUpdatePickupTime(locationOpenHourOfParticularBranch[0]?.sundayOpenTime);
                        }
                    } else {
                        setUpdateReturnTime(locationOpenHourOfParticularBranch[0]?.sundayOpenTime);
                    }
                }
                break;
            case 1:
                if (locationOpenHourOfParticularBranch[0]?.mondayOpenTime) {
                    if (isPickupTime) {
                        if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.mondayOpenTime, 'HH:mm'))) {
                            setUpdatePickupTime(locationOpenHourOfParticularBranch[0]?.mondayOpenTime);
                        }
                    } else {
                        setUpdateReturnTime(locationOpenHourOfParticularBranch[0]?.mondayOpenTime);
                    }
                }
                break;
            case 2:
                if (locationOpenHourOfParticularBranch[0]?.tuesdayOpenTime) {
                    if (isPickupTime) {
                        if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.tuesdayOpenTime, 'HH:mm'))) {
                            setUpdatePickupTime(locationOpenHourOfParticularBranch[0]?.tuesdayOpenTime);
                        }
                    } else {
                        setUpdateReturnTime(locationOpenHourOfParticularBranch[0]?.tuesdayOpenTime);
                    }
                }
                break;
            case 3:
                if (locationOpenHourOfParticularBranch[0]?.wednesdayOpenTime) {
                    if (isPickupTime) {
                        if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.wednesdayOpenTime, 'HH:mm'))) {
                            setUpdatePickupTime(locationOpenHourOfParticularBranch[0]?.wednesdayOpenTime);
                        }
                    } else {
                        setUpdateReturnTime(locationOpenHourOfParticularBranch[0]?.wednesdayOpenTime);
                    }
                }
                break;
            case 4:
                if (locationOpenHourOfParticularBranch[0]?.thursdayOpenTime) {
                    if (isPickupTime) {
                        if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.thursdayOpenTime, 'HH:mm'))) {
                            setUpdatePickupTime(locationOpenHourOfParticularBranch[0]?.thursdayOpenTime);
                        }
                    } else {
                        setUpdateReturnTime(locationOpenHourOfParticularBranch[0]?.thursdayOpenTime);
                    }
                }
                break;
            case 5:
                if (locationOpenHourOfParticularBranch[0]?.fridayOpenTime) {
                    if (isPickupTime) {
                        if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.fridayOpenTime, 'HH:mm'))) {
                            setUpdatePickupTime(locationOpenHourOfParticularBranch[0]?.fridayOpenTime);
                        }
                    } else {
                        setUpdateReturnTime(locationOpenHourOfParticularBranch[0]?.fridayOpenTime);
                    }
                }
                break;
            case 6:
                if (locationOpenHourOfParticularBranch[0]?.saturdayOpenTime) {
                    if (isPickupTime) {
                        if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.saturdayOpenTime, 'HH:mm'))) {
                            setUpdatePickupTime(locationOpenHourOfParticularBranch[0]?.saturdayOpenTime);
                        }
                    } else {
                        setUpdateReturnTime(locationOpenHourOfParticularBranch[0]?.saturdayOpenTime);
                    }
                }
                break;
        }
    }

    useEffect(() => {
        if (new Date(updatePickupDate)?.getTime() === new Date(updateReturnDate)?.getTime() && updateReturnDate <= updatePickupDate) {
            setIsValid(false);
            setReturnTimeMessage("Return Time must greater than pickup Time");
        } else {
            setIsValid(true);
            setReturnTimeMessage("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updatePickupDate, updatePickupTime, updateReturnDate, updateReturnTime]);

    const selectedBranch = useMemo(() => {
        return branches?.find((branch: any) => branch.id === parseInt(updateBranch));
    }, [updateBranch, branches]);

    const minAllowedHoursToBook = selectedBranch ? selectedBranch?.minAllowedHoursToBook : 0;

    useEffect(() => {
        const pickupDateTime = new Date(`${updatePickupDate}T${updatePickupTime}`);
        const returnDateTime = new Date(`${updateReturnDate}T${updateReturnTime}`);

        const timeDifferenceInMs = returnDateTime.getTime() - pickupDateTime.getTime();
        const timeDifferenceInHours = timeDifferenceInMs / (1000 * 60 * 60);

        if (new Date(updatePickupDate).getTime() === new Date(updateReturnDate).getTime()) {
            if (timeDifferenceInHours < minAllowedHoursToBook) {
                setMinBookingMessage(
                    `The minimum booking duration is ${minAllowedHoursToBook} hours.`
                );
                setIsValid(false);
            } else {
                setMinBookingMessage("");
                setIsValid(true);
            }
        } else {
            setMinBookingMessage("");
            setIsValid(true);
        }
    }, [updatePickupDate, updatePickupTime, updateReturnDate, updateReturnTime, minAllowedHoursToBook]);


    if (!showPopup) return null;

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (
            new Date(locationOpenHourOfParticularBranch[0]?.startDate) <=
            new Date(updatePickupDate.replaceAll("-", "/")) &&
            new Date(locationOpenHourOfParticularBranch[0]?.endDate) >=
            new Date(updateReturnDate.replaceAll("-", "/"))
        ) {
            if (isValid && moment(updatePickupDate, "YYYY-MM-DD", true).isValid() && moment(updateReturnDate, "YYYY-MM-DD", true).isValid()) {
                const pickupDateTime = moment(`${updatePickupDate}T${updatePickupTime}`).format('YYYY-MM-DDTHH:mm');
                const returnDateTime = moment(`${updateReturnDate}T${updateReturnTime}`).format('YYYY-MM-DDTHH:mm');
                axios.get(`${baseURL}blockedDay/GetBlockedDaysByStartDateAndEndDate/${pickupDateTime},${returnDateTime}`, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                    }
                })
                    .then((res) => {
                        if (res.data.length > 0) {
                            if (res.data[0]?.isAllDay) {
                                setConfirmData({
                                    title: `We are closed on ${moment(res.data[0]?.startDate.split('T')[0]).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))
                                        === moment(updatePickupDate).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))
                                        ? moment(updatePickupDate).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))
                                        : moment(res.data[0]?.startDate.split('T')[0]).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))
                                            === moment(updateReturnDate).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))
                                            ? moment(updateReturnDate).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))
                                            : moment(updatePickupDate).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))}`,
                                    confirmBtn: "Ok",
                                    isConfirm: (callback: any) => {

                                        callback();
                                    }
                                });
                                setConfirmPopup(true);
                            } else {
                                const df = webData?.dateFormat?.replace(/yyyy/g, "YYYY") || "DD/MM/YYYY";
                                setConfirmData({
                                    title: `We are closed on ${moment(res.data[0]?.startDate?.split("T")?.[0]).format(df) ===
                                        moment(updatePickupDate).format(df)
                                        ? moment(updatePickupDate).format(df)
                                        : moment(res.data[0]?.startDate?.split("T")?.[0]).format(df) ===
                                            moment(updateReturnDate).format(df)
                                            ? moment(updateReturnDate).format(df)
                                            : ""
                                        } between ${moment(
                                            `${res.data[0]?.startDate?.split("T")?.[0]}T${res.data[0]?.startTime}`,
                                            [`YYYY-MM-DDTHH:mm`, `${df}THH:mm`],
                                            true
                                        ).format("hh:mm a")
                                        } to ${moment(
                                            `${res.data[0]?.startDate?.split("T")?.[0]}T${res.data[0]?.endTIme}`,
                                            [`YYYY-MM-DDTHH:mm`, `${df}THH:mm`],
                                            true
                                        ).format("hh:mm a")
                                        }`,
                                    confirmBtn: "Ok",
                                    isConfirm: (callback: any) => {
                                        callback();
                                    }

                                });
                                setConfirmPopup(true);
                            }
                        } else {
                            let pickupDateMessages = "";
                            let returnDateMessages = "";
                            let pickupTimeMessages = "";
                            let returnTimeMessages = "";
                            switch (new Date(updatePickupDate.replaceAll("-", "/")).getDay()) {
                                case 0:
                                    if (locationOpenHourOfParticularBranch[0].isSundayOpen) {
                                        pickupDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].sundayOpenTime <=
                                            updatePickupTime &&
                                            locationOpenHourOfParticularBranch[0].sundayCloseTime >=
                                            updatePickupTime
                                        ) {
                                            pickupTimeMessages = "";
                                        } else {
                                            pickupTimeMessages =
                                                "Office on Sunday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].sundayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].sundayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        pickupDateMessages = "Office is closed on Sunday";
                                    }
                                    break;
                                case 1:
                                    if (locationOpenHourOfParticularBranch[0].isMondayOpen) {
                                        pickupDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].mondayOpenTime <=
                                            updatePickupTime &&
                                            locationOpenHourOfParticularBranch[0].mondayCloseTime >=
                                            updatePickupTime
                                        ) {
                                            pickupTimeMessages = "";
                                        } else {
                                            pickupTimeMessages = "Office on Monday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].mondayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].mondayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        pickupDateMessages = "Office is closed on Monday";
                                    }
                                    break;
                                case 2:
                                    if (locationOpenHourOfParticularBranch[0].isTuesdayOpen) {
                                        pickupDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].tuesdayOpenTime <=
                                            updatePickupTime &&
                                            locationOpenHourOfParticularBranch[0].tuesdayCloseTime >=
                                            updatePickupTime
                                        ) {
                                            pickupTimeMessages = "";
                                        } else {
                                            pickupTimeMessages =
                                                "Office on Tuesday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].tuesdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].tuesdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        pickupDateMessages = "Office is closed on Tuesday";
                                    }
                                    break;
                                case 3:
                                    if (locationOpenHourOfParticularBranch[0].isWednesdayOpen) {
                                        pickupDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].wednesdayOpenTime <=
                                            updatePickupTime &&
                                            locationOpenHourOfParticularBranch[0].wednesdayCloseTime >=
                                            updatePickupTime
                                        ) {
                                            pickupTimeMessages = "";
                                        } else {
                                            pickupTimeMessages =
                                                "Office on Wednesday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].wednesdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].wednesdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        pickupDateMessages = "Office is closed on Wednesday";
                                    }
                                    break;
                                case 4:
                                    if (locationOpenHourOfParticularBranch[0].isThursdayOpen) {
                                        pickupDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].thursdayOpenTime <=
                                            updatePickupTime &&
                                            locationOpenHourOfParticularBranch[0].thursdayCloseTime >=
                                            updatePickupTime
                                        ) {
                                            pickupTimeMessages = "";
                                        } else {
                                            pickupTimeMessages =
                                                "Office on Thursday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].thursdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].thursdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        pickupDateMessages = "Office is closed on Thursday";
                                    }
                                    break;
                                case 5:
                                    if (locationOpenHourOfParticularBranch[0].isFridayOpen) {
                                        pickupDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].fridayOpenTime <=
                                            updatePickupTime &&
                                            locationOpenHourOfParticularBranch[0].fridayCloseTime >=
                                            updatePickupTime
                                        ) {
                                            pickupTimeMessages = "";
                                        } else {
                                            pickupTimeMessages =
                                                "Office on Friday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].fridayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].fridayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        pickupDateMessages = "Office is closed on Friday";
                                    }
                                    break;
                                case 6:
                                    if (locationOpenHourOfParticularBranch[0].isSaturdayOpen) {
                                        pickupDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].saturdayOpenTime <=
                                            updatePickupTime &&
                                            locationOpenHourOfParticularBranch[0].saturdayCloseTime >=
                                            updatePickupTime
                                        ) {
                                            pickupTimeMessages = "";
                                        } else {
                                            pickupTimeMessages =
                                                "Office on Saturday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].saturdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].saturdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        pickupDateMessages = "Office is closed on Saturday";
                                    }
                                    break;
                            }

                            switch (new Date(updateReturnDate.replaceAll("-", "/")).getDay()) {
                                case 0:
                                    if (locationOpenHourOfParticularBranch[0].isSundayOpen) {
                                        returnDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].sundayOpenTime <=
                                            updateReturnTime &&
                                            locationOpenHourOfParticularBranch[0].sundayCloseTime >=
                                            updateReturnTime
                                        ) {
                                            returnTimeMessages = "";
                                        } else {
                                            returnTimeMessages =
                                                "Office on Sunday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].sundayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].sundayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        returnDateMessages = "Office is closed on Sunday";
                                    }
                                    break;
                                case 1:
                                    if (locationOpenHourOfParticularBranch[0].isMondayOpen) {
                                        returnDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].mondayOpenTime <=
                                            updateReturnTime &&
                                            locationOpenHourOfParticularBranch[0].mondayCloseTime >=
                                            updateReturnTime
                                        ) {
                                            returnTimeMessages = "";
                                        } else {
                                            returnTimeMessages =
                                                "Office on Monday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].mondayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].mondayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        returnDateMessages = "Office is closed on Monday";
                                    }
                                    break;
                                case 2:
                                    if (locationOpenHourOfParticularBranch[0].isTuesdayOpen) {
                                        returnDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].tuesdayOpenTime <=
                                            updateReturnTime &&
                                            locationOpenHourOfParticularBranch[0].tuesdayCloseTime >=
                                            updateReturnTime
                                        ) {
                                            returnTimeMessages = "";
                                        } else {
                                            returnTimeMessages =
                                                "Office on Tuesday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].tuesdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].tuesdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        returnDateMessages = "Office is closed on Tuesday";
                                    }
                                    break;
                                case 3:
                                    if (locationOpenHourOfParticularBranch[0].isWednesdayOpen) {
                                        returnDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].wednesdayOpenTime <=
                                            updateReturnTime &&
                                            locationOpenHourOfParticularBranch[0].wednesdayCloseTime >=
                                            updateReturnTime
                                        ) {
                                            returnTimeMessages = "";
                                        } else {
                                            returnTimeMessages =
                                                "Office on Wednesday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].wednesdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].wednesdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        returnDateMessages = "Office is closed on Wednesday";
                                    }
                                    break;
                                case 4:
                                    if (locationOpenHourOfParticularBranch[0].isThursdayOpen) {
                                        returnDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].thursdayOpenTime <=
                                            updateReturnTime &&
                                            locationOpenHourOfParticularBranch[0].thursdayCloseTime >=
                                            updateReturnTime
                                        ) {
                                            returnTimeMessages = "";
                                        } else {
                                            returnTimeMessages =
                                                "Office on Thursday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].thursdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].thursdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        returnDateMessages = "Office is closed on Thursday";
                                    }
                                    break;
                                case 5:
                                    if (locationOpenHourOfParticularBranch[0].isFridayOpen) {
                                        returnDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].fridayOpenTime <=
                                            updateReturnTime &&
                                            locationOpenHourOfParticularBranch[0].fridayCloseTime >=
                                            updateReturnTime
                                        ) {
                                            returnTimeMessages = "";
                                        } else {
                                            returnTimeMessages =
                                                "Office on Friday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].fridayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].fridayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        returnDateMessages = "Office is closed on Friday";
                                    }
                                    break;
                                case 6:
                                    if (locationOpenHourOfParticularBranch[0].isSaturdayOpen) {
                                        returnDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].saturdayOpenTime <=
                                            updateReturnTime &&
                                            locationOpenHourOfParticularBranch[0].saturdayCloseTime >=
                                            updateReturnTime
                                        ) {
                                            returnTimeMessages = "";
                                        } else {
                                            returnTimeMessages =
                                                "Office on Saturday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].saturdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].saturdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        returnDateMessages = "Office is closed on Saturday";
                                    }
                                    break;
                            }

                            setPleasWaitPopup(true);

                            if (pickupDateMessages === "" &&
                                pickupTimeMessages === "" &&
                                returnDateMessages === "" &&
                                returnTimeMessages === "" &&
                                minBookingMessage === "") {
                                updateTheDatesAndLocation();
                            } else {
                                setPleasWaitPopup(false);
                                closeModal();
                                setConfirmPopup(true);
                                setConfirmData({
                                    title: `${pickupDateMessages} ${pickupTimeMessages} ${returnDateMessages} ${returnTimeMessages}`,
                                    confirmBtn: "Ok",
                                    isConfirm: (callback: any) => {
                                        callback();
                                    }
                                });
                            }

                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
            }
            else {
                setConfirmPopup(true);
                setConfirmData({
                    title: `Please fill valid Information`,
                    confirmBtn: "Ok",
                    isConfirm: (callback: any) => {

                        callback();
                    }
                });
            }
        } else {
            setConfirmPopup(true);
            setConfirmData({
                title: `We are closed on ${moment(pickupDate).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))} 
                and ${moment(returnDate).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))}`,
                confirmBtn: "Ok",
                isConfirm: (callback: any) => {

                    callback();
                }
            });
        }
    }

    const updateTheDatesAndLocation = () => {
        setPickupLocationId(upadatePickupLocationId);
        setReturnLocationId(upadateReturnLocationId);
        setPickupDate(updatePickupDate);
        setReturnDate(updateReturnDate);
        setPickupTime(updatePickupTime);
        setReturnTime(updateReturnTime);
        setReturnToDifferent(updateReturnToDifferent);
        setBranchId(updateBranch)
        setLocationFeeAmount(selectedLocation?.locationFee);
        setTaxAmount(selectedLocation?.tax);
        setMandatoryAdditionalChargesAmount(selectedLocation?.mandatoryAdditionalCharges);
        setGovernmentTaxAmount(selectedLocation?.governmentTax);
        setPleasWaitPopup(false);
        closeModal();
        updateResevation();
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 overflow-auto">
            <div className="w-full max-w-6xl mx-4 bg-white p-6 rounded-xl shadow-lg relative">
                <div className="flex justify-end">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320.591 320.591"
                        className="w-4 h-4 cursor-pointer fill-gray-600"
                        onClick={closeModal}
                    >
                        <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" />
                        <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" />
                    </svg>
                </div>

                <form className="space-y-6" onSubmit={handleSubmit}>
                    {/* Pickup & Return Inputs */}
                    <div className="flex flex-col md:flex-row gap-4">
                        {/* Pickup Location */}
                        <div className="w-full space-y-2 relative" ref={pickupWrapperRef}>
                            <label className="text-sm font-semibold">
                                Pickup Location {updateReturnToDifferent ? "" : "and Return Location"}
                            </label>
                            <div className="w-full border rounded-lg px-1 text-sm flex items-center">
                                <input
                                    type="text"
                                    placeholder="Search Location"
                                    className="w-full outline-none px-4 py-3"
                                    value={pickupSearch}
                                    onChange={(e) => setPickupSearch(e.target.value)}
                                    onFocus={() => setPickupIsFocused(true)}
                                    required
                                />
                                {
                                    pickupSearch && (
                                        <button
                                            onClick={() => setPickupSearch("")}
                                            className="text-black mx-2"
                                        >
                                            <span className="material-symbols-outlined text-lg">
                                                close
                                            </span>
                                        </button>
                                    )
                                }
                            </div>
                            {pickupIsFocused && pickupFilteredOptions?.length > 0 && (
                                <ul className="absolute z-10 mt-1 w-full bg-white border rounded-md shadow-lg max-h-52 overflow-y-auto text-sm">
                                    {pickupFilteredOptions?.map((option) => (
                                        <li
                                            key={option?.value}
                                            onClick={() => {
                                                if (!updateReturnToDifferent) {
                                                    setUpadatePickupLocationId(option?.value);
                                                    setUpadateReturnLocationId(option?.value);
                                                } else {
                                                    setUpadatePickupLocationId(option?.value);
                                                }
                                                setPickupSearch(option?.label);
                                                setSelectedLocation(option);
                                                setUpdateBranch(option?.branchId);
                                                setPickupIsFocused(false);

                                            }}
                                            className={`p-3 cursor-pointer bg-gray-100 border-b hover:bg-white hover:font-semibold ${webData?.hoverPrimaryTextColor}`}
                                        >
                                            {option?.label}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>

                        {/* Return Location (if different) */}
                        {updateReturnToDifferent && (
                            <div className="w-full space-y-2 relative" ref={returnWrapperRef}>
                                <label className="text-sm font-semibold">Return Location</label>
                                <div className="w-full border rounded-lg px-1 text-sm flex items-center">
                                    <input
                                        type="text"
                                        placeholder="Search Location"
                                        className="w-full outline-none px-4 py-3"
                                        value={returnSearch}
                                        onChange={(e) => setReturnSearch(e.target.value)}
                                        onFocus={() => setReturnIsFocused(true)}
                                        required
                                    />
                                    {
                                        returnSearch && (
                                            <button
                                                onClick={() => setReturnSearch("")}
                                                className="text-black mx-2"
                                            >
                                                <span className="material-symbols-outlined text-lg">
                                                    close
                                                </span>
                                            </button>
                                        )
                                    }
                                </div>

                                {returnIsFocused && returnFilteredOptions?.length > 0 && (
                                    <ul className="absolute z-10 mt-1 w-full bg-white border rounded-md shadow-lg max-h-52 overflow-y-auto text-sm">
                                        {returnFilteredOptions?.map((option) => (
                                            <li
                                                key={option?.value}
                                                onClick={() => {
                                                    setUpadateReturnLocationId(option?.value);
                                                    setReturnSearch(option?.label);
                                                    setReturnIsFocused(false);
                                                }}
                                                className={`p-3 cursor-pointer bg-gray-100 border-b hover:bg-white hover:font-semibold ${webData?.textPrimaryColor}`}
                                            >
                                                {option?.label}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Checkbox */}
                    <div className="flex items-center space-x-2">
                        <input
                            id="return-diff"
                            type="checkbox"
                            className="w-5 h-5 text-blue-600 border-gray-300 rounded"
                            checked={updateReturnToDifferent}
                            onChange={() => setUpdateReturnToDifferent(!updateReturnToDifferent)}
                        />

                        <label htmlFor="return-diff" className="text-sm font-medium">
                            Return to a different location
                        </label>
                    </div>

                    <div className="flex flex-col lg:flex-row gap-6">
                        {/* Pickup */}
                        <div className="w-full lg:w-1/2">
                            <label className="block text-sm font-medium mb-1">Pickup Date & Time</label>
                            <div className="flex flex-col gap-2 md:flex-row md:gap-0">
                                <div className="relative w-full md:w-1/2">
                                    <CustomDateField
                                        value={updatePickupDate}
                                        onChange={(value) => {
                                            setUpdatePickupDate(value);

                                            if (new Date(value) >= new Date(updateReturnDate)) {
                                                setUpdateReturnDate(moment(value).add(1, 'day').format('YYYY-MM-DD'));
                                            }
                                        }}
                                        dateFormat={webData?.dateFormat?.replace(/yyyy/g, 'YYYY')}
                                        minDate={new Date().toISOString().split("T")[0]}
                                        className="w-full px-4 py-[19px] border md:rounded-tr-none md:rounded-br-none md:rounded-tl-lg md:rounded-bl-lg rounded-lg flex items-center justify-between text-sm bg-white"
                                        showValidMessage={true}
                                        required={true}
                                    />
                                </div>

                                <div className="w-full md:w-1/2">
                                    <InputPicker
                                        type="time"
                                        inputRef={pickupTimeRef}
                                        inputValue={updatePickupTime}
                                        setInputValue={(inputValue) => setUpdatePickupTime(inputValue)}
                                        required
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Return */}
                        <div className="w-full lg:w-1/2">
                            <label className="block text-sm font-medium mb-1">Return Date & Time</label>
                            <div className="flex flex-col gap-2 md:flex-row md:gap-0">
                                <div className="relative w-full md:w-1/2">
                                    <CustomDateField
                                        value={updateReturnDate}
                                        onChange={setUpdateReturnDate}
                                        dateFormat={webData?.dateFormat?.replace(/yyyy/g, 'YYYY')}
                                        minDate={updatePickupDate}
                                        className="w-full px-4 py-[19px] border md:rounded-tr-none md:rounded-br-none md:rounded-tl-lg md:rounded-bl-lg rounded-lg flex items-center justify-between text-sm bg-white"
                                        showValidMessage={true}
                                        required={true}
                                    />
                                </div>

                                <div className="w-full md:w-1/2">
                                    <InputPicker
                                        type="time"
                                        inputRef={returnTimeRef}
                                        inputValue={updateReturnTime}
                                        setInputValue={(inputValue) => setUpdateReturnTime(inputValue)}
                                        required
                                    />
                                </div>
                            </div>

                            {returnTimeMessage && (
                                <p className="text-xs text-red-500 mt-1">{returnTimeMessage}</p>
                            )}

                            {minBookingMessage && (
                                <p className="text-xs text-red-500 mt-1">{minBookingMessage}</p>
                            )}
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div className="md:w-full md:flex md:justify-end pt-4">
                        <button
                            type="submit"
                            className="w-full md:w-auto hover:opacity-90 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-200"
                            style={{ backgroundColor: webData?.websiteHeaderColor }}
                        >
                            Update
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}